import {
  StyleSheet,
  View,
  ImageBackground,
  useWindowDimensions,
  ViewStyle,
} from 'react-native';
import React from 'react';
import {spacing} from 'theme/Units';
import {Button} from 'ui-kits';
import ActionCard from './Card';
import {staticDataForScreen} from 'constants/DefaultValues';
import Video from 'react-native-video';
import {mergeDeepRight} from 'ramda';

// import AI featuers
const {actions: ACTIONS} = staticDataForScreen.landing_screen;

type propType = Readonly<{
  openModal: () => void;
}>;

export function AIAction(props: propType) {
  const {openModal} = props;
  // require keyword for typescript
  const bgImage = require('assets/images/AI_action/background.png');

  /**
   * responsiveness logic
   */
  const {width: SCREEN_WIDTH} = useWindowDimensions();

  let overrideStyles = structuredClone(baseStyles);

  // 1024 px break point
  if (SCREEN_WIDTH < 1024) {
    overrideStyles.grid.gridTemplateColumns = 'repeat(3, 1fr)';
    overrideStyles.grid.gridTemplateRows = 'repeat(3, 1fr)';
    overrideStyles.container.padding = spacing['10'];
  }

  // 720 px break point
  if (SCREEN_WIDTH < 720) {
    overrideStyles.grid.gridTemplateColumns = 'repeat(2, 1fr)';
    overrideStyles.grid.gridTemplateRows = 'repeat(4, 1fr)';
    overrideStyles.grid.rowGap = spacing['6'];
    overrideStyles.grid.columnGap = spacing['3'];
    overrideStyles.container.padding = spacing['6'];
  }

  // 640 px break point
  if (SCREEN_WIDTH < 640) {
    overrideStyles.container.padding = spacing['4'];
    overrideStyles.grid.rowGap = spacing['4'];
  }

  // 480 px break point
  if (SCREEN_WIDTH < 480) {
    overrideStyles.container.padding = spacing['3'];
    overrideStyles.grid.rowGap = spacing['3'];
  }

  const styles: styleType = mergeDeepRight(baseStyles, overrideStyles) as any;

  return (
    <View style={styles.container}>
      <View id="cover" style={styles.videoContainer}>
        <Video
          resizeMode="stretch"
          paused={false}
          muted={true}
          controls={false}
          id="cover"
          poster={bgImage}
          repeat={true}
          source={{uri: '/videos/bluerays.mp4'}}
          style={styles.video}
        />
      </View>
      <View style={styles.grid}>
        {ACTIONS.map(item => (
          <ActionCard key={item.id} {...item} />
        ))}
      </View>
      <Button variant="primary" text="Discover AI in action" />
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  videoContainer: ViewStyle;
  video: ViewStyle;
  grid: ViewStyle;
};

const baseStyles: styleType = {
  container: {
    alignItems: 'center',
    padding: spacing['14'],
  },
  videoContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
  },
  video: {
    objectPosition: 'top',
  },
  grid: {
    display: 'grid',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridTemplateColumns: 'repeat(4, 1fr)',
    rowGap: spacing['8'],
    columnGap: spacing['4'],
    marginBottom: spacing['8'],
    maxWidth: 1240,
  },
};
